import { render, staticRenderFns } from "./noDataPermission.vue?vue&type=template&id=226ff71a&scoped=true"
var script = {}
import style0 from "./noDataPermission.vue?vue&type=style&index=0&id=226ff71a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226ff71a",
  null
  
)

export default component.exports